import { Component, OnInit } from '@angular/core';
import { AgFilterComponent } from 'ag-grid-angular';
import { IDoesFilterPassParams, AgPromise, IFilterParams } from 'ag-grid-community';
import { IScheduleItem } from 'src/app/contracts/schedule-items.service';

@Component({
  selector: 'app-schedule-status-filter',
  templateUrl: './schedule-status-filter.component.html',
  styleUrls: ['./schedule-status-filter.component.scss']
})
export class ScheduleStatusFilterComponent implements AgFilterComponent {
  params: IFilterParams | undefined;
  selectedOption = "All"

  constructor() { }

  agInit(params: IFilterParams): void {
    this.params = params;
  }

  isFilterActive(): boolean {
    return this.selectedOption !== 'All';
  }

  doesFilterPass(params: IDoesFilterPassParams): boolean {
    const scheduleItem: IScheduleItem = params.data;
    if (this.selectedOption === "All") { return true; }

    if (this.selectedOption === "All Incomplete") {
      return scheduleItem.Status !== "Completed"
    }
    return this.selectedOption === scheduleItem.Status
  }

  getModel() {
    return this.selectedOption;
  }

  setModel(model: any): void | AgPromise<void> {
    this.selectedOption = model ?? 'All';
    this.params?.filterChangedCallback();
  }
}
